/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddClientTeamMember200ResponseUser
 */
export interface AddClientTeamMember200ResponseUser {
    /**
     * Keycloak user UUID of the newly created member.
     */
    id?: string;
}

/**
 * Check if a given object implements the AddClientTeamMember200ResponseUser interface.
 */
export function instanceOfAddClientTeamMember200ResponseUser(value: object): value is AddClientTeamMember200ResponseUser {
    return true;
}

export function AddClientTeamMember200ResponseUserFromJSON(json: any): AddClientTeamMember200ResponseUser {
    return AddClientTeamMember200ResponseUserFromJSONTyped(json, false);
}

export function AddClientTeamMember200ResponseUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddClientTeamMember200ResponseUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function AddClientTeamMember200ResponseUserToJSON(json: any): AddClientTeamMember200ResponseUser {
    return AddClientTeamMember200ResponseUserToJSONTyped(json, false);
}

export function AddClientTeamMember200ResponseUserToJSONTyped(value?: AddClientTeamMember200ResponseUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

